// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 10/10/2023
 */


 .containerTwo_redBoxTop__yJopC{
  position: relative;
  padding: 2.5rem 1.25rem;
  border-radius: 0.5rem;
  background: #002566;
  box-shadow: 0px 4px 20px 0px rgba(50, 50, 71, 0.04), 0px 4px 4px 0px rgba(0, 0, 0, 0.01);
  color: #FFF;
  width: 36rem;
  margin-left: auto;
  margin-top: 14rem;
  margin-bottom: 6rem;
  max-width: 50rem;
  z-index: 2;
}

.containerTwo_redBoxBottom__lOElb {
  position: relative;
  padding: 2.5rem 1.25rem;
  border-radius: 0.5rem;
  background: #002566
  ;
  box-shadow: 0px 4px 20px 0px rgba(50, 50, 71, 0.04), 0px 4px 4px 0px rgba(0, 0, 0, 0.01);
  color: #FFF;
  width: 36rem;
  margin: 1rem auto;
  max-width: 50rem;
  left: 0;
  z-index: 2;
}

.containerTwo_title__fWgC2 {
  font-size: 1.5rem;
  padding-bottom: 1rem;
}

.containerTwo_description__xg-g3 {
  font-size: 1rem;
}

.containerTwo_imageContainer__Zsoda {
  position: absolute;
  left: 5%;
  padding-bottom: 5rem;
  margin-top: -21rem;
}

.containerTwo_image__Btk1v {
  position: relative;
  z-index: 1;
}

/* mobile screen */
@media (max-width: 770px) {
  .containerTwo_title__fWgC2 {
    font-size: 1rem;
    padding-bottom: 1rem;
  }

  .containerTwo_description__xg-g3 {
    font-size: 0.75rem;
  }

  .containerTwo_imageContainer__Zsoda {
    position: absolute;
    left: 5%;
    padding-bottom: 5rem;
    margin-top: -6.5rem;
  }

  .containerTwo_image__Btk1v {
    height: 12.5rem;
    /* width: 18rem; */
  }

  .containerTwo_redBoxTop__yJopC{
    padding: 1rem 1.25rem;
    width: 17rem;
    right: 0;
    margin-top: 1rem;
  }
  .containerTwo_redBoxBottom__lOElb {
    padding: 1rem 1.25rem;
    width: 17rem;
    margin-top: 12rem;
    left: 0;
  }
}

@media (min-width: 1450px) {
  .containerTwo_imageContainer__Zsoda {
    position: absolute;
    left: 15%;
    padding-bottom: 5rem;
    margin-top: -21rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/aboutUs/containerTwo.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;;CAGD;EACC,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,wFAAwF;EACxF,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB;EACA;EACA,wFAAwF;EACxF,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,OAAO;EACT;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,kBAAkB;EACpB;AACF","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 10/10/2023\r\n */\r\n\r\n\r\n .redBoxTop{\r\n  position: relative;\r\n  padding: 2.5rem 1.25rem;\r\n  border-radius: 0.5rem;\r\n  background: #002566;\r\n  box-shadow: 0px 4px 20px 0px rgba(50, 50, 71, 0.04), 0px 4px 4px 0px rgba(0, 0, 0, 0.01);\r\n  color: #FFF;\r\n  width: 36rem;\r\n  margin-left: auto;\r\n  margin-top: 14rem;\r\n  margin-bottom: 6rem;\r\n  max-width: 50rem;\r\n  z-index: 2;\r\n}\r\n\r\n.redBoxBottom {\r\n  position: relative;\r\n  padding: 2.5rem 1.25rem;\r\n  border-radius: 0.5rem;\r\n  background: #002566\r\n  ;\r\n  box-shadow: 0px 4px 20px 0px rgba(50, 50, 71, 0.04), 0px 4px 4px 0px rgba(0, 0, 0, 0.01);\r\n  color: #FFF;\r\n  width: 36rem;\r\n  margin: 1rem auto;\r\n  max-width: 50rem;\r\n  left: 0;\r\n  z-index: 2;\r\n}\r\n\r\n.title {\r\n  font-size: 1.5rem;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.description {\r\n  font-size: 1rem;\r\n}\r\n\r\n.imageContainer {\r\n  position: absolute;\r\n  left: 5%;\r\n  padding-bottom: 5rem;\r\n  margin-top: -21rem;\r\n}\r\n\r\n.image {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n/* mobile screen */\r\n@media (max-width: 770px) {\r\n  .title {\r\n    font-size: 1rem;\r\n    padding-bottom: 1rem;\r\n  }\r\n\r\n  .description {\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .imageContainer {\r\n    position: absolute;\r\n    left: 5%;\r\n    padding-bottom: 5rem;\r\n    margin-top: -6.5rem;\r\n  }\r\n\r\n  .image {\r\n    height: 12.5rem;\r\n    /* width: 18rem; */\r\n  }\r\n\r\n  .redBoxTop{\r\n    padding: 1rem 1.25rem;\r\n    width: 17rem;\r\n    right: 0;\r\n    margin-top: 1rem;\r\n  }\r\n  .redBoxBottom {\r\n    padding: 1rem 1.25rem;\r\n    width: 17rem;\r\n    margin-top: 12rem;\r\n    left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 1450px) {\r\n  .imageContainer {\r\n    position: absolute;\r\n    left: 15%;\r\n    padding-bottom: 5rem;\r\n    margin-top: -21rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"redBoxTop": `containerTwo_redBoxTop__yJopC`,
	"redBoxBottom": `containerTwo_redBoxBottom__lOElb`,
	"title": `containerTwo_title__fWgC2`,
	"description": `containerTwo_description__xg-g3`,
	"imageContainer": `containerTwo_imageContainer__Zsoda`,
	"image": `containerTwo_image__Btk1v`
};
export default ___CSS_LOADER_EXPORT___;
